import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import "./style.css";
import filter from "../../../images/icons/filter.png";
import editIcon from "../../../images/icons/edit.png";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Modal from "react-bootstrap/Modal";
import viewIcon from "../../../images/view.png";
import UOMView from "./view";
import UOMAdd from "./Add";
import UOMEdit from "./Edit";
import {
  apiDeletePltCommon,
  apiEditPltCommon,
  apiListPltCommon,
} from "../../../api/master";
import Swal from "sweetalert2";

function UOMList() {
  const initialState = {
    uom_name: "",
    is_active: "",
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showId, setShowId] = useState(0);
  const [editId, setEditId] = useState("");

  const [formInputs, setFormInputs] = useState(initialState);
  const [filtersVisible, setFiltersVisible] = useState(false);

  const [user, setUser] = useState({});
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  async function changeStatus(ptl_id, status, uom_name) {
    let target = window.event.target;
    let oldText = target.innerText;
    target.innerText = "Updating...";
    await apiDeletePltCommon({
      ptl_id: ptl_id,
      is_active: status,
    })
      .then((data) => {
        setError("");
      })
      .catch((err) => {
        setError(err.response?.data?.data?.message || err.message);
        setTimeout(function () {
          setError("");
        }, 3000);
      })
      .finally(() => {
        target.innerText = oldText;
        getList(filtersVisible);
      });
  }

  async function getList(isFilter = true, pageNo = null) {
    let json = {
      plt_name: "item_uom",
      paginate: 1,
      page_no: (pageNo || currentPage) - 1,
    };
    if (isFilter) {
      json = { ...json, ...formInputs };
      json = JSON.parse(
        JSON.stringify(json, (_, v) => (v === "" ? undefined : v)),
      );
    }
    await apiListPltCommon(json)
      .then((data) => {
        setCurrentPage(pageNo || currentPage);
        setIsSubmit(false);
        const responseData = data?.data?.data;
        if (Array.isArray(responseData)) {
          setList(responseData);
          setTotalPage(responseData.length);
        } else if (responseData?.list) {
          setList(responseData.list);
          setTotalPage(responseData.count || 0);
        } else {
          setList([]);
          setTotalPage(0);
        }
        setIsLoading(false);
      })
      .catch(function (err) {
        setIsSubmit(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response?.data?.data?.message || err.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      });
  }

  useEffect(
    function () {
      getList(filtersVisible);
    },
    [currentPage],
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  return (
    <>
      <div
        className="d-flex min-vh-100 main-Wrapper"
        style={{ background: "#DAE5FF" }}
      >
        <Sidebar />
        <div className="content m-1  p-2">
          <Header />
          <main className="bg-white rounded-4" id="buyer">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["UOM Master"]} />
                </div>
                <div className="col text-end"
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                  }}
                >
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2.5rem" }}
                    />
                  </Tippy>

                  {user.role_id === 3 || user.role_id === 4 ? (
                    ""
                  ) : (
                    <Link
                      onClick={(v) => {
                        handleShow();
                        setShowId(1);
                      }}
                      className="btn btn-primary px-4 py-2"
                      style={{
                        height: "33px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Add UOM
                    </Link>
                  )}
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  autoComplete="off"
                >
                  <div className="row" id="buyerAdd">
                    <div className="col-6">
                      <label htmlFor="uom_name">UOM Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="uom_name"
                        value={formInputs.uom_name}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="is_active">Status</label>
                      <select
                        className="form-select"
                        value={formInputs.is_active}
                        onChange={handleInputs}
                        id="is_active"
                      >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">In-Active</option>
                      </select>
                    </div>
                    <div className="col-md-4 mt-auto">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2"
                        type="button"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{ background: "#4263eb", fontSize: "14px" }}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {error && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-danger py-1 small`}
                      role="alert"
                    >
                      {error || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col">
                  <table className={`table ${error ? "my-1" : "mt-4"} rounded`}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>UOM Name</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || (list?.length || 0) == 0) && (
                        <tr>
                          <td colSpan="4" className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list?.map((v, i) => (
                        <tr key={`uom_` + i}>
                          <td>{currentPage * 10 - 10 + i + 1}</td>
                          <td>{v.plt_val}</td>
                          <td>
                            {v.comp_id == null ? (
                              <span className="badge text-bg-secondary">
                                Default
                              </span>
                            ) : user.role_id === 3 || user.role_id === 4 ? (
                              <Tippy disabled>
                                {v.is_active ? (
                                  <span
                                    className="badge text-bg-success"
                                    role="button"
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span
                                    className="badge text-bg-danger"
                                    role="button"
                                  >
                                    In-Active
                                  </span>
                                )}
                              </Tippy>
                            ) : (
                              <Tippy content="Change Status">
                                {v.is_active ? (
                                  <span
                                    className="badge text-bg-success"
                                    role="button"
                                    onClick={() =>
                                      changeStatus(v.ptl_id, 0, v.plt_val)
                                    }
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span
                                    className="badge text-bg-danger"
                                    role="button"
                                    onClick={() =>
                                      changeStatus(v.ptl_id, 1, v.plt_val)
                                    }
                                  >
                                    In-Active
                                  </span>
                                )}
                              </Tippy>
                            )}
                          </td>
                          <td>
                            <Tippy content="View" trigger="mouseenter">
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setEditId(v);
                                  handleShow();
                                  setShowId(3);
                                }}
                              >
                                <img
                                  src={viewIcon}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                              </a>
                            </Tippy>

                            {v.comp_id != null &&
                              (user.role_id === 3 || user.role_id === 4 ? (
                                ""
                              ) : (
                                <Tippy content="Edit" trigger="mouseenter">
                                  <Link
                                    onClick={() => {
                                      setEditId(v);
                                      handleShow();
                                      setShowId(2);
                                    }}
                                    className={`link-info ${v.is_active ? "" : "d-none"
                                      }`}
                                  >
                                    <img
                                      src={editIcon}
                                      className="img-fluid me-2"
                                      alt=""
                                    />
                                  </Link>
                                </Tippy>
                              ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / 10)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
              <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                backdrop="static"
              >
                {showId == 1 ? (
                  <UOMAdd id={editId} list={getList} hide={handleClose} />
                ) : showId == 2 ? (
                  <UOMEdit id={editId} list={getList} hide={handleClose} />
                ) : showId == 3 ? (
                  <UOMView id={editId} list={getList} hide={handleClose} />
                ) : null}
              </Modal>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default UOMList;
